import { useSelector } from "react-redux";
import { RootReducer } from "RootReducer";

// Internal preview access only: design previews (e.g. /optimize) are hidden
// behind this allowlist until they are released to partners.
const SUPER_ADMIN_MAILS = [
  "gunay@gamelight.io",
  "flo@gamelight.io",
  "sukru@gamelight.io",
];

export const useSuperAdmin = () => {
  const accountInfo = useSelector(
    (state: RootReducer) => state.authentication.accountInfo
  );

  const isLoaded = accountInfo !== null;
  const mail = accountInfo?.mail?.toLowerCase() ?? "";

  return {
    isLoaded,
    isSuperAdmin: SUPER_ADMIN_MAILS.includes(mail),
  };
};
